import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Componente que renderiza o modal de confirmação para remoção de comprovante.
 * @param {boolean} open - Controla a visibilidade do modal.
 * @param {Function} handleClose - Função chamada para fechar o modal.
 * @param {Function} handleDelete - Função chamada para confirmar a remoção.
 * @param {number|string} comprovanteId - ID do comprovante que está sendo removido.
 */
function DeleteComprovanteModal({ open, handleClose, handleDelete, comprovanteId }) {
    return (
        <Modal show={open} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Remover Comprovante</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Deseja realmente remover este comprovante?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Não
                </Button>
                <Button variant="danger" onClick={() => handleDelete(comprovanteId)}>
                    Sim
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteComprovanteModal;
